export const getCameraStream = async (
  deviceId: string,
): Promise<MediaStream> => {
  const videoConstraints: MediaTrackConstraints = deviceId
    ? { deviceId: { exact: deviceId } }
    : {};

  const stream = await navigator.mediaDevices.getUserMedia({
    video: videoConstraints,
    audio: false,
  });

  return stream;
};

export const waitForVideoReady = (
  video: HTMLVideoElement,
  timeoutMs = 5000,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const check = () =>
      video.readyState >= 2 && video.videoWidth > 0 && video.videoHeight > 0;

    if (check()) {
      resolve();
      return;
    }

    let pollId: ReturnType<typeof setInterval> | null = null;

    const cleanup = () => {
      if (pollId) {
        clearInterval(pollId);
      }
      clearTimeout(timer);
      video.removeEventListener("loadeddata", onLoaded);
    };

    const timer = setTimeout(() => {
      cleanup();
      reject(new Error("Video ready timeout"));
    }, timeoutMs);

    const onLoaded = () => {
      if (check()) {
        cleanup();
        resolve();
      }
    };

    video.addEventListener("loadeddata", onLoaded, { once: true });

    // Also poll, because loadeddata may have already fired while videoWidth was still 0
    pollId = setInterval(() => {
      if (check()) {
        cleanup();
        resolve();
      }
    }, 100);
  });
};
